import React from "react";

import { IconZoomOut } from "~/components/icon";
import { type Impulse, useScope } from "~/tools/impulse";

import type { TimeRange } from "../../../../app/state/view/timeline/TimeRange";
import { IconButton, type IconButtonSize } from "../Buttons";

export interface ZoomOutProps {
	className?: string;
	timeRange: Impulse<TimeRange>;
	size?: IconButtonSize;
	contextName: string;
	disabled?: boolean;
}

export const ZoomOut: React.FC<ZoomOutProps> = ({ timeRange, contextName, disabled = false, ...props }) => {
	const scope = useScope();

	return (
		<IconButton
			data-testid="timeline-zoom-out"
			disabled={disabled || !timeRange.getValue(scope).isLessLimit()}
			icon={<IconZoomOut className="text-xs/[23px]" />}
			onClick={() => timeRange.setValue((current) => current.zoomOut())}
			size="middle"
			tooltip={`Zoom-out of the current ${contextName} interval (max. 6 months)`}
			{...props}
		/>
	);
};
